import { render, staticRenderFns } from "./DiscountCouponEditDialog.vue?vue&type=template&id=6a0cd967&scoped=true"
import script from "./DiscountCouponEditDialog.vue?vue&type=script&lang=js"
export * from "./DiscountCouponEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0cd967",
  null
  
)

export default component.exports